import {
  LOCALE_NL,
  LOCALE_NL_BE,
  LOCALE_NL_NL,
  LOCALE_EN_GB,
  LOCALE_EN,
  LOCAL_EN_US,
} from '@derolfgroep/intl/lib/constants'
import { mergeLabels } from '@derolfgroep/intl/lib/labels/labels'
import labelsNlNl from './nl-NL.json'
import labelsEnGb from './en-GB.json'

const nlLocales = [LOCALE_NL, LOCALE_NL_NL, LOCALE_NL_BE]
const enLocales = [LOCALE_EN, LOCALE_EN_GB, LOCAL_EN_US]

export const labelsForLocale = (locale) => {
  if (nlLocales.includes(locale)) {
    return mergeLabels(LOCALE_NL_NL, labelsNlNl)
  }
  if (enLocales.includes(locale)) {
    return mergeLabels(LOCALE_EN_GB, labelsEnGb)
  }
  return mergeLabels(LOCALE_NL_NL, labelsNlNl)
}
